import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Star, LogIn, Menu, X } from 'lucide-react';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const APP_URL = (import.meta.env.VITE_APP_URL && import.meta.env.VITE_APP_URL !== 'undefined')
    ? import.meta.env.VITE_APP_URL
    : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      ? 'http://localhost:5173'
      : 'https://app.superasso.fr';

  const isHome = location.pathname === '/' || location.pathname === '/login';
  const isDocsOrContact = location.pathname === '/docs' || location.pathname === '/contact';

  const navLinks = [
    { name: 'Accueil', href: '/', type: 'link', show: isDocsOrContact },
    { name: 'Outils', href: '#features', type: 'anchor', show: isHome },
    { name: 'Tarifs', href: '#pricing', type: 'anchor', show: isHome },
    { name: 'FAQ', href: '/faq', type: 'link', show: true },
    { name: 'Docs', href: '/docs', type: 'link', show: true },
    { name: 'Contact', href: '/contact', type: 'link', show: true },
  ];

  // Logic pour filtrer les liens visibles
  const visibleLinks = navLinks.filter(link => link.show);

  return (
    <nav className="fixed w-full z-50 bg-[#24574E]/80 backdrop-blur-lg border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex justify-between h-20 items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 bg-[#F9D965] rounded-full flex items-center justify-center text-[#24574E] shadow-lg transition-transform group-hover:scale-110">
              <Star size={20} fill="currentColor" />
            </div>
            <span className="text-xl font-bold tracking-tight uppercase text-white">SuperAsso</span>
            <span className="px-1.5 py-0.5 text-[10px] font-bold tracking-widest uppercase border border-white/20 rounded text-white/40">
              Beta
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-10">
            {visibleLinks.map((link) => (
              link.type === 'anchor' ? (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm font-bold text-[#F5F3EE]/60 hover:text-[#F9D965] transition-colors"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={link.href}
                  className="text-sm font-bold text-[#F5F3EE]/60 hover:text-[#F9D965] transition-colors"
                >
                  {link.name}
                </Link>
              )
            ))}

            <div className="w-px h-4 bg-white/10 mx-2" />

            <a
              href={`${APP_URL}/profil`}
              className="bg-white/10 border border-white/20 px-6 py-2 rounded-full text-sm font-bold text-white hover:bg-white/20 transition-all flex items-center gap-2"
            >
              <LogIn size={16} />
              Connexion
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden p-2 text-white/60 hover:text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#24574E] border-b border-white/5 px-6 py-8 space-y-6 animate-in slide-in-from-top duration-300">
          <div className="flex flex-col gap-6">
            {visibleLinks.map((link) => (
              link.type === 'anchor' ? (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-lg font-bold text-[#F5F3EE]/60 hover:text-[#F9D965]"
                >
                  {link.name}
                </a>
              ) : (
                <Link
                  key={link.name}
                  to={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-lg font-bold text-[#F5F3EE]/60 hover:text-[#F9D965]"
                >
                  {link.name}
                </Link>
              )
            ))}

            <hr className="border-white/5" />

            <a
              href={`${APP_URL}/profil`}
              onClick={() => setIsMobileMenuOpen(false)}
              className="w-full bg-white/10 text-white py-4 rounded-2xl font-black flex items-center justify-center gap-3 shadow-lg"
            >
              <LogIn size={20} />
              Connexion
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
